import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from './MarketingLayout';

const RELEASES = [
  {
    date: 'April 8, 2026',
    tag: 'Product Launch',
    tagColor: '#eff6ff', tagText: '#2563eb',
    title: 'ClickSaver Launches Advanced Fraud Detection Platform for Google Ads Advertisers',
    excerpt: 'ClickSaver today announced the general availability of its AI-powered click fraud detection and prevention platform, helping advertisers protect their Google Ads budgets from invalid traffic and competitor abuse.',
  },
  {
    date: 'March 20, 2026',
    tag: 'Growth',
    tagColor: '#f0fdf4', tagText: '#059669',
    title: 'ClickSaver Surpasses 500 Active Customers, Protecting Over $2M in Monthly Ad Spend',
    excerpt: 'The platform has now identified and blocked over 3.8 million fraudulent clicks since launch, saving customers an average of 18–25% of their Google Ads spend.',
  },
  {
    date: 'March 5, 2026',
    tag: 'Partnership',
    tagColor: '#f5f3ff', tagText: '#7c3aed',
    title: 'ClickSaver Announces Google Ads API Certification',
    excerpt: 'ClickSaver has completed the Google Ads API certification process, enabling deeper integration with Google Ads accounts for automatic IP exclusion and campaign-level protection.',
  },
  {
    date: 'February 14, 2026',
    tag: 'Feature',
    tagColor: '#fff7ed', tagText: '#d97706',
    title: 'ClickSaver Introduces Custom Detection Rules for Enterprise Advertisers',
    excerpt: 'The new Custom Rules feature allows Advanced plan subscribers to build tailored fraud detection logic based on ISP, time-of-day, device type, and geographic signals specific to their industry.',
  },
];

const ASSETS = [
  { icon: '🖼️', label: 'Logo Pack (SVG + PNG)', desc: 'Full colour, white, and dark variants' },
  { icon: '📸', label: 'Product Screenshots', desc: 'Dashboard, analytics, and settings views' },
  { icon: '👤', label: 'Founder Photos', desc: 'High-res headshots for press use' },
  { icon: '📄', label: 'Company Fact Sheet', desc: 'Key metrics, founding story, team size' },
];

export default function Press() {
  return (
    <MarketingLayout>
      {/* Hero */}
      <section style={{ padding: '80px 24px 60px', background: 'linear-gradient(180deg,#f8faff 0%,#fff 100%)', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: '#f5f3ff', color: '#7c3aed', fontSize: 12, fontWeight: 700, letterSpacing: '1.2px', textTransform: 'uppercase', padding: '5px 14px', borderRadius: 40, border: '1px solid #ddd6fe', marginBottom: 20 }}>Press & Media</div>
        <h1 style={{ fontSize: 48, fontWeight: 900, letterSpacing: '-2px', marginBottom: 16 }}>Press Room</h1>
        <p style={{ fontSize: 18, color: '#475569', maxWidth: 480, margin: '0 auto 32px' }}>Latest news, press releases, and media resources from ClickSaver.</p>
        <a href="mailto:press@clicksaver.app" style={{ background: '#2563eb', color: '#fff', textDecoration: 'none', padding: '12px 28px', borderRadius: 10, fontSize: 15, fontWeight: 600 }}>Press Enquiries →</a>
      </section>

      {/* Quick facts */}
      <section style={{ padding: '0 24px 60px', background: '#fff' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 1, background: '#e2e8f0', border: '1px solid #e2e8f0', borderRadius: 16, overflow: 'hidden' }}>
          {[
            { value: '500+', label: 'Active customers' },
            { value: '$2M+', label: 'Monthly ad spend protected' },
            { value: '3.8M', label: 'Fraudulent clicks blocked' },
            { value: '2025', label: 'Founded' },
          ].map((s, i) => (
            <div key={i} style={{ background: '#fff', padding: '28px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 900, color: '#2563eb', letterSpacing: '-1px', marginBottom: 4 }}>{s.value}</div>
              <div style={{ fontSize: 13, color: '#64748b' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Press releases */}
      <section style={{ padding: '0 24px 80px', background: '#f8fafc' }}>
        <div style={{ maxWidth: 860, margin: '0 auto' }}>
          <h2 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 32 }}>Press Releases</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {RELEASES.map((r, i) => (
              <div key={i} style={{ background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: 14, padding: '24px 28px' }}>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 10 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, background: r.tagColor, color: r.tagText, padding: '3px 10px', borderRadius: 20 }}>{r.tag}</span>
                  <span style={{ fontSize: 12, color: '#94a3b8' }}>{r.date}</span>
                </div>
                <h3 style={{ fontSize: 17, fontWeight: 700, color: '#0f172a', lineHeight: 1.4, marginBottom: 10 }}>{r.title}</h3>
                <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 14 }}>{r.excerpt}</p>
                <a href="#" style={{ fontSize: 13, color: '#2563eb', fontWeight: 600, textDecoration: 'none' }}>Read full release →</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Media kit */}
      <section style={{ padding: '60px 24px 80px', background: '#fff' }}>
        <div style={{ maxWidth: 860, margin: '0 auto' }}>
          <h2 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 8 }}>Media Kit</h2>
          <p style={{ fontSize: 15, color: '#64748b', marginBottom: 32 }}>Download approved assets for use in editorial coverage of ClickSaver.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16 }}>
            {ASSETS.map((a, i) => (
              <div key={i} style={{ border: '1.5px solid #e2e8f0', borderRadius: 14, padding: '20px', textAlign: 'center', cursor: 'pointer', transition: 'all .2s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#bfdbfe'; e.currentTarget.style.background = '#f8faff'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = '#fff'; }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>{a.icon}</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#0f172a', marginBottom: 4 }}>{a.label}</div>
                <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 14 }}>{a.desc}</div>
                <span style={{ fontSize: 12, color: '#2563eb', fontWeight: 600 }}>Download ↓</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section style={{ padding: '60px 24px 80px', background: '#f8fafc', textAlign: 'center' }}>
        <h2 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 10 }}>Press contact</h2>
        <p style={{ fontSize: 16, color: '#64748b', marginBottom: 6 }}>For interview requests, editorial enquiries, and fact-checking:</p>
        <a href="mailto:press@clicksaver.app" style={{ fontSize: 16, color: '#2563eb', fontWeight: 600, textDecoration: 'none' }}>press@clicksaver.app</a>
        <p style={{ fontSize: 14, color: '#94a3b8', marginTop: 8 }}>We aim to respond to all press enquiries within one business day.</p>
      </section>
    </MarketingLayout>
  );
}
